(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConcertsController', ConcertsController);

    ConcertsController.$inject = ['$scope', '$http', '$stateParams', '$rootScope', 'cache', '$state', 'localization', '$cookies', 'eventTracker'];

    function ConcertsController($scope, $http, $stateParams, $rootScope, cache, $state, localization, $cookies, eventTracker) {
        $rootScope.header_inverted = true;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.resultsPerPage = 24;
        vm.page = 1;
        vm.concerts = [];
        vm.freetext = "";
        vm.searchString = "";
        vm.dateFilter = "any";
        vm.sourcePage = "list_concerts"
        vm.sortBy = "concert_date";
        vm.dateRangeStart = new Date();
        vm.activeFilters = 0;
        vm.selected_genres = [];
        vm.selected_tags = [];
        vm.getConcerts = getConcerts;
        vm.getSelectedLocations = getSelectedLocations;
        vm.getSelectedAdminFilters = getSelectedAdminFilters;
        vm.selectedGenres = selectedGenres;
        vm.selectedTags = selectedTags;
        vm.countActiveDateAndTagFilters = countActiveDateAndTagFilters;
        vm.countActiveFilters = countActiveFilters;
        vm.selectGenre = selectGenre;
        vm.selectTag = selectTag;
        vm.search = search;
        vm.dateFilterChanged = dateFilterChanged;
        vm.selectLocation = selectLocation;
        vm.selectAdminFilter = selectAdminFilter;
        vm.searchBlur = searchBlur;
        vm.clearText = clearText;
        vm.clearSearchAndFilters = clearSearchAndFilters;
        vm.toggleFilterSort = toggleFilterSort;
        vm.toggleLocationFilter = toggleLocationFilter;
        vm.toggleGenreFilter = toggleGenreFilter;
        vm.toggleMoreFilter = toggleMoreFilter;
        vm.toggleSortFilter = toggleSortFilter;
        vm.toggleSearchFilter = toggleSearchFilter;
        vm.closeFilters = closeFilters;
        vm.updatePage = updatePage;
        vm.navigateToConcert = navigateToConcert;
        vm.locationChanged = locationChanged;
        vm.chosenLocations;
        vm.locations = [];
        vm.adminFilters = [
            { adminFilter: "All-Star", adminFilterSlug: "all_star" },
            { adminFilter: "Superhost", adminFilterSlug: "superhost" }
        ];
        vm.searchInputFocus = searchInputFocus
        vm.searchOnEnter = searchOnEnter;

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
        });

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Koncerter – Be My Concert" : "Concerts – Be My Concert";
            vm.concerts = [];
            getUser();
            if(!localization.location){
                vm.current_location = $cookies.get('selected_location');
            }else{
                vm.current_location = localization.location;
            }
            if(vm.current_location != 'Sweden' && vm.current_location != 'Denmark'){
                vm.current_location = 'Denmark';
            }
            changeCurrentLocationIso();
            if (cache.exists('tags')) {
                vm.tags = cache.load('tags');
            } else {
                getTags().then(function () {
                });
            }
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                getCountryRegions();
            } else {
                getGenres().then(function () {
                getCountryRegions();
                });
            }
        }

        function locationChanged() {
            vm.current_location = localization.location;
            vm.country_filter = vm.current_location;
            vm.page = 1;
            changeCurrentLocationIso();
            clearSelectedLocations();
            setCountryRegions();
            getConcerts();
            updatePage();
            $scope.$applyAsync();
            setTimeout(function() {
                setFilterState();
            }, 50);
        }

        function navigateToConcert(concert) {
            cache.save('scrollY', window.scrollY);
        }

        function updatePage(page) {
            if (page > 0 && page <= Math.ceil(parseInt(vm.allResultsCount) / vm.resultsPerPage)) {
                vm.page = page;
                getConcerts();
                setFilterState();
            }
        }

        function clearSearchAndFilters() {
            vm.dateFilter = 'any';
            vm.dateRangeStart = new Date();
            vm.dateRangeEnd = null;
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
            vm.adminFilters.forEach(function (adminFilter) {
                adminFilter.selected = false;
            });
            vm.genres.forEach(function (genre) {
                genre.selected = false;
            });
            vm.tags.forEach(function (tag) {
                tag.selected = false;
            });
            setActiveFilters();
            setFilterState();
            clearText();
            search();
        }

        function clearText() {
            vm.freetext = '';
            vm.showSearch = false;
            vm.showSearchResults = false;
            if(cache.load('searchData').freetext != "") {
                search();
            }
        }

        function clearSelectedLocations() {
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
        }

        function clearSelectedAdminFilters() {
            vm.adminFilters.forEach(function (adminFilter) {
                adminFilter.selected = false;
            });
        }

        function searchBlur(event) {
            if (vm.freetext != '') {
                setTimeout(function () { vm.searchFocus = false; }, 0);
            } else {
                vm.searchFocus = false;
            }
        }

        function searchOnEnter(event){
            if (event.keyCode == 13){
                search();
            }
        }

        function searchInputFocus(elementID){
            vm.showSearch = !vm.showSearch;
            vm.searchFocus = true;
            if(elementID){
                var element = document.getElementById(elementID);
                setTimeout(function(){
                    element.focus();
                }, 200);
            }
        }

        function setFilterFromState() {
            if ($stateParams.location != 'all') {
                var URILocations = decodeURI($stateParams.location).split(';');
                vm.locations.forEach(function (location) {
                    URILocations.forEach(function (URILocation) {
                        if (location.country_region_name == URILocation) {
                            location.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.adminFilter != 'all') {
                var URIAdminFilters = decodeURI($stateParams.adminFilter).split(';');
                vm.adminFilters.forEach(function (adminFilter) {
                    URIAdminFilters.forEach(function (URIAdminFilter) {
                        if (adminFilter.adminFilter == URIAdminFilter) {
                            adminFilter.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.genre != 'any') {
                var URIgenres = decodeURI($stateParams.genre).split(';');
                vm.genres.forEach(function (genre) {
                    URIgenres.forEach(function (URIGenre) {
                        if (genre.filter_value_name == URIGenre) {
                            genre.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.tag != 'any') {
                var URItags = decodeURI($stateParams.tag).split(';');
                vm.tags.forEach(function (tag) {
                    URItags.forEach(function (URITag) {
                        if (tag.tag_id == URITag) {
                            tag.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.page != '1') {
                vm.page = $stateParams.page;
            }
            vm.sortBy = $stateParams.sort;
            vm.freetext = $stateParams.search;
            vm.dateFilter = $stateParams.date_filter;
            vm.dateRangeStart = new Date($stateParams.date_start);
            vm.dateRangeEnd = $stateParams.date_end != "" ? new Date($stateParams.date_end) : null;
            vm.country_filter = $stateParams.country_filter != "" ? $stateParams.country_filter : vm.current_location;

            setActiveFilters()
        }

        function selectLocation(location) {
            location.selected = !location.selected;
            setFilterState();
            search();
        }

        function selectAdminFilter(adminFilter) {
            adminFilter.selected = !adminFilter.selected;
            setFilterState();
            search();
        }

        function setFilterState() {
            var params = JSON.parse(JSON.stringify($stateParams));
            if (getSelectedLocations().length > 0) {
                var uriString = '';
                getSelectedLocations().forEach(function (location) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(location.country_region_name);
                });
                params.location = uriString;
            } else {
                params.location = 'all';
            }
            if (getSelectedAdminFilters().length > 0) {
                var uriString = '';
                getSelectedAdminFilters().forEach(function (adminFilter) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(adminFilter.adminFilter);
                });
                params.adminFilter = uriString;
            } else {
                params.adminFilter = 'all';
            }
            if (selectedGenres().length > 0) {
                var uriString = '';
                selectedGenres().forEach(function (genre) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(genre.filter_value_name);
                });
                params.genre = uriString;
            } else {
                params.genre = 'any';
            }
            if (selectedTags().length > 0) {
                var uriString = '';
                selectedTags().forEach(function (tag) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(tag.tag_id);
                });
                params.tag = uriString;
            } else {
                params.tag = 'any';
            }
            params.page = vm.page;
            params.sort = vm.sortBy;
            params.search = vm.freetext;
            params.date_filter = vm.dateFilter;
            params.country_filter = vm.country_filter;
            params.date_start = vm.dateRangeStart.toJSON();
            params.date_end = vm.dateRangeEnd ? vm.dateRangeEnd.toJSON() : '';
            $state.transitionTo(
                'concerts',
                params,
                {
                    location: true, // This makes it update URL
                    inherit: true,
                    relative: $state.$current,
                    notify: false // This makes it not reload
                }
            );
        }

        function setActiveFilters() {
            var num = 0;
            if (vm.dateFilter != 'any') num++;
            num += selectedGenres().length;
            num += selectedTags().length;
            vm.activeFilters = num;
        }

        function dateFilterChanged() {
            if (vm.dateFilter == 'any') {
                vm.dateRangeStart = new Date();
                vm.dateRangeEnd = null;
                search();
            }
            if (vm.dateFilter == 'this_week') {
                vm.dateRangeStart = new Date();
                vm.dateRangeEnd = moment().endOf("week").toDate();
                search();
            }
            if (vm.dateFilter == 'this_month') {
                vm.dateRangeStart = new Date();
                vm.dateRangeEnd = moment().endOf("month").toDate();
                search();
            }
            if (vm.dateFilter == 'other') {
                vm.dateRangeStart = new Date();
                vm.dateRangeEnd = null;
            }
        }

        function selectedGenres() {
            if (!vm.genres) return [];
            var selectedGenres = [];
            vm.genres.forEach(function (genre) {
                if (genre.selected) {
                    selectedGenres.push(genre)
                }
            });
            return selectedGenres;
        }

        function selectedTags() {
            if (!vm.tags) return [];
            var selectedTags = [];
            vm.tags.forEach(function (tag) {
                if (tag.selected) {
                    selectedTags.push(tag)
                }
            });
            return selectedTags;
        }

        function countActiveDateAndTagFilters() {
            var count = 0;
            count += vm.selectedTags().length;
            if (vm.dateFilter == 'this_week' || vm.dateFilter == 'this_month' || vm.dateFilter == 'other'){
                count ++;
            }
            return count;
        }

        function countActiveFilters() {
            var count = 0;
            count += vm.selectedTags().length;
            count += vm.selectedGenres().length;
            if (vm.dateFilter == 'this_week' || vm.dateFilter == 'this_month' || vm.dateFilter == 'other'){
                count ++;
            }
            return count;
        }

        function selectGenre(genre) {
            genre.selected = !genre.selected;
            setFilterState();
            search();
        }

        function selectTag(tag) {
            tag.selected = !tag.selected;
            setFilterState();
            search();
        }

        function getGenres() {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
            return $http.get('api/genres/')
                .then(function (response) {
                    vm.genres = response.data;
                    cache.save('genres', vm.genres);
                });
            }
        }

        function getTags() {
            if (cache.exists('tags')) {
                vm.tags = cache.load('tags');
                return Promise.resolve();
            } else {
            return $http.get('api/active_tags/')
                .then(function (response) {
                    vm.tags = response.data;
                    cache.save('tags', vm.tags);
                });
            }
        }

        function toggleFilterSort() {
            vm.showFilterSort = !vm.showFilterSort;
            $rootScope.no_scroll = vm.showFilterSort;
        }

        function toggleLocationFilter() {
            vm.showLocation = !vm.showLocation;
            $rootScope.no_scroll = vm.showLocation;
        }

        function toggleGenreFilter() {
            vm.showGenre = !vm.showGenre;
            $rootScope.no_scroll = vm.showGenre;
        }

        function toggleMoreFilter() {
            vm.showMore = !vm.showMore;
            $rootScope.no_scroll = vm.showMore;
        }

        function toggleSortFilter() {
            vm.showSort = !vm.showSort;
            $rootScope.no_scroll = vm.showSort;
        }

        function toggleSearchFilter() {
            vm.showSearch = !vm.showSearch;
            $rootScope.no_scroll = vm.showSearch;
        }

        function closeFilters() {
            vm.showLocation = false;
            vm.showGenre = false;
            vm.showMore = false;
            vm.showSort = false;
            vm.showSearch = false;
            vm.showFilterSort = false;
            $rootScope.no_scroll = false;
        }

        function getSelectedLocations() {
            var selectedLocations = [];
            vm.locations.forEach(location => {
                if (location.selected) selectedLocations.push(location);
            });
            return selectedLocations;
        }

        function getSelectedAdminFilters() {
            var selectedAdminFilters = [];
            vm.adminFilters.forEach(adminFilter => {
                if (adminFilter.selected) selectedAdminFilters.push(adminFilter);
            });
            return selectedAdminFilters;
        }

        function getConcerts() {
            var offset = (vm.page - 1) * vm.resultsPerPage;
            vm.dateRangeStart.setHours(0, 0, 0, 0);
            if (vm.dateRangeEnd) { vm.dateRangeEnd.setHours(23, 59, 59, 0); }
            var data = {
                'genre': selectedGenres(),
                'tag': selectedTags(),
                'freetext': vm.freetext,
                'country' : localization.getLocationIso(vm.country_filter),
                'location': getSelectedLocations(),
                'adminFilter': getSelectedAdminFilters(),
                'limit': vm.resultsPerPage,
                'offset': offset,
                'sortby': vm.sortBy,
                'dateRangeStart': vm.dateRangeStart,
                'dateRangeEnd': vm.dateRangeEnd
            }
            if (cache.exists('searchData') && cache.equals('searchData', data)) {
                vm.concerts = cache.load('concerts');
                if(vm.concerts.length > 0){
                    if (selectedGenres().length != 1) {
                        eventTracker.impressionView(vm.concerts, "Concerts Page Concert List", vm.page);
                    }
                    eventTracker.detailView(vm.concerts, "Concerts Page Concert List");
                }
                vm.allResultsCount = cache.load('allResultsCount');
                if($rootScope.previousURL.search('/concert/') != -1) {
                    setTimeout(function () {
                        window.scrollTo(0, cache.load('scrollY'));
                    }, 0);
                }

                updateViewState()
                return;
            }
            return $http.post('api/list/concerts/', data)
                .then(function (response) {
                    vm.concerts = response.data.data;
                    if(vm.concerts.length > 0){
                        if (selectedGenres().length != 1) {
                            eventTracker.impressionView(vm.concerts, "Concerts Page Concert List", vm.page);
                        }
                        eventTracker.detailView(vm.concerts, "Concerts Page Concert List");
                    }
                    vm.allResultsCount = response.data.all_results_count;
                    saveState(data, response.data.all_results_count);
                    updateViewState();
                });
        }

        function updateViewState() {
            vm.searchString = vm.freetext != "" ? vm.freetext : "";
            if (vm.concerts.length == 0) {
                vm.showNoResults = true;
            } else {
                vm.showNoResults = false;

                if (vm.searchString != "") {
                    vm.showSearchResults = true;
                    vm.searchFocus = false;
                } else {
                    vm.showSearchResults = false;
                }
            }
            $rootScope.$emit('update_pagination', {
                total:vm.allResultsCount,
                page: vm.page,
                size: vm.resultsPerPage
            });
        }

        function getCountryRegions() {
            if(!cache.exists('concertCountryRegions')){
                $http.get('api/concert_country_regions/')
                .then(function (response) {
                    vm.allCountryRegions = response.data;
                    cache.save('concertCountryRegions', vm.allCountryRegions);
                    if(vm.current_location){
                        setCountryRegions();
                    }
                })
                .then(function (response) {
                    setFilterFromState();
                })
                .then(function (response) {
                   getConcerts();
                });
            } else {
                loadRegionsFromCache();
                setFilterFromState();
                getConcerts();
            }
        }

        function getUser() {
            return $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    return response.data;
                });
        }

        function loadRegionsFromCache() {
            vm.allCountryRegions = cache.load('concertCountryRegions');
            if(vm.current_location){
                setCountryRegions();
            }
        }

        function setCountryRegions() {
            vm.countryRegions = vm.allCountryRegions.filter(function(countryRegion) {
                return countryRegion.country_iso_code == vm.current_location_iso;
            });
            vm.locations = vm.countryRegions;
        }

        function changeCurrentLocationIso(){
            if(vm.current_location == "Denmark"){
                vm.current_location_iso = "DK"
            }
            if(vm.current_location == "Sweden"){
                vm.current_location_iso = "SE"
            }
        }

        function saveState(searchData, allResultsCount) {
            cache.save('searchData', searchData);
            cache.save('concerts', vm.concerts);
            cache.save('allResultsCount', allResultsCount);
        }

        function search() {
            vm.allResultsCount = undefined;
            vm.page = 1;
            getConcerts();
            setActiveFilters();
            setFilterState();
        }

    }
})();
